export default __webpack_public_path__ + "routing-800-3d6d8ad59939e47040869e1b1d8477dd.webp";